import { Injectable, NgZone } from '@angular/core';
export var MalihuScrollbarService = (function () {
    function MalihuScrollbarService(zone) {
        this.zone = zone;
    }
    MalihuScrollbarService.prototype.initScrollbar = function (element, options) {
        var _this = this;
        this.zone.runOutsideAngular(function () { return _this.getElement(element).mCustomScrollbar(options); });
    };
    MalihuScrollbarService.prototype.scrollTo = function (element, parameter, options) {
        var _this = this;
        this.zone.runOutsideAngular(function () { return _this.getElement(element).mCustomScrollbar('scrollTo', parameter, options); });
    };
    MalihuScrollbarService.prototype.update = function (element) {
        var _this = this;
        this.zone.runOutsideAngular(function () { return _this.getElement(element).mCustomScrollbar('update'); });
    };
    MalihuScrollbarService.prototype.stop = function (element) {
        var _this = this;
        this.zone.runOutsideAngular(function () { return _this.getElement(element).mCustomScrollbar('stop'); });
    };
    MalihuScrollbarService.prototype.disable = function (element) {
        var _this = this;
        this.zone.runOutsideAngular(function () { return _this.getElement(element).mCustomScrollbar('disable'); });
    };
    MalihuScrollbarService.prototype.destroy = function (element) {
        var _this = this;
        this.zone.runOutsideAngular(function () { return _this.getElement(element).mCustomScrollbar('destroy'); });
    };
    MalihuScrollbarService.prototype.getElement = function (element) {
        if (typeof element === 'string' || element instanceof String) {
            return $(element);
        }
        if ((typeof element === 'object' || element instanceof Object) && element instanceof HTMLElement) {
            return $(element);
        }
        if (element instanceof jQuery || 'jquery' in Object(element)) {
            return element;
        }
        throw Error("Unsupported element type in MalihuScrollbarService: " + element);
    };
    MalihuScrollbarService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    MalihuScrollbarService.ctorParameters = function () { return [
        { type: NgZone, },
    ]; };
    return MalihuScrollbarService;
}());
//# sourceMappingURL=malihu-scrollbar.service.js.map


//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/ngx-malihu-scrollbar/dist/lib/malihu-scrollbar.service.js
// module id = ../../../../ngx-malihu-scrollbar/dist/lib/malihu-scrollbar.service.js
// module chunks = 4